import { colors } from '@resurs/midas'

export default {
  board: {
    background: colors.primary0,
    overflow: 'hidden',
    border: '1px solid',
    borderColor: 'transparent',
    borderRadius: '12px',
  },
  label: {
    textAlign: 'center',
    marginTop: '4rem',
    fontSize: '3rem',
    color: colors.gray1,
    fontWeight: 'normal',
  },
  result: {
    textAlign: 'center',
    fontSize: '4rem',
    marginTop: '-1.5rem',
    color: colors.primary8,
    fontWeight: 'bold',
  },
  comment: {
    textAlign: 'center',
    marginBottom: '3rem',
    color: colors.gray1,
  },
  selections: {
    marginTop: '1.5rem',
    background: colors.primary1,
    padding: '1rem',
    textAlign: 'center',
    color: colors.primary8,
  },
}
